module.exports = __webpack_public_path__ + "img/banner1.f60b65ed.png";